<div>
  <app-phone-number-input
    [control]="phoneControl"
    [placeholder]="field.config.placeholder">
  </app-phone-number-input>
</div>
